import { Pipe, PipeTransform } from '@angular/core';
import { StatusKonfiguracjiDyplomowania } from '@interfaces/dyplomowanie/enums/status-konfiguracji-dyplomowania.enum';

@Pipe({
  name: 'statusKonfiguracji',
})
export class StatusKonfiguracjiPipe implements PipeTransform {
  transform(value: StatusKonfiguracjiDyplomowania): string {
    const { Przestarzala, Aktualna, Przyszla } = StatusKonfiguracjiDyplomowania;
    switch (value) {
      case Przestarzala:
        return 'bg-muted';
      case Aktualna:
        return 'bg-success';
      case Przyszla:
        return 'bg-info';
      default:
        return '';
    }
  }
}
